import { type UnderlyingSymbol } from "#/types/markets";
import {
  getInstrumentProperties,
  isOptionInstrument,
} from "#/utils/instrument.utils";

export const MIN_SIZE_OPTIONS = {
  BTC: 0.01,
  ETH: 0.1,
};

export const MIN_SIZE_PERPS = {
  BTC: MIN_SIZE_OPTIONS.BTC / 100,
  ETH: MIN_SIZE_OPTIONS.ETH / 100,
};

export const constraints = {
  perps: {
    BTC: {
      minSize: MIN_SIZE_PERPS.BTC,
      maxSizeNotional: 25_000,
      sizeDisplayPrecision: Math.ceil(-Math.log10(MIN_SIZE_PERPS.BTC)),
      sizeDisplayPrecisionNotional: 0,
      priceDisplayPrecisionNotional: 0,
    },
    ETH: {
      minSize: MIN_SIZE_PERPS.ETH,
      maxSizeNotional: 25_000,
      sizeDisplayPrecision: Math.ceil(-Math.log10(MIN_SIZE_PERPS.ETH)),
      sizeDisplayPrecisionNotional: 0,
      priceDisplayPrecisionNotional: 1,
    },
  },
  options: {
    BTC: {
      minSize: MIN_SIZE_OPTIONS.BTC,
      maxSize: 2,
      sizeDisplayPrecision: Math.ceil(-Math.log10(MIN_SIZE_OPTIONS.BTC)),
      sizeDisplayPrecisionNotional: 2,
      priceDisplayPrecisionNotional: 0,
    },
    ETH: {
      minSize: MIN_SIZE_OPTIONS.ETH,
      maxSize: 50,
      sizeDisplayPrecision: Math.ceil(-Math.log10(MIN_SIZE_OPTIONS.ETH)),
      sizeDisplayPrecisionNotional: 2,
      priceDisplayPrecisionNotional: 1,
    },
  },
  general: {
    BTC: {
      maxNumberOfOrders: 10,
    },
    ETH: {
      maxNumberOfOrders: 10,
    },
  },
};

export const getPerpConstraints = (underlying: UnderlyingSymbol) => {
  return constraints.perps[underlying];
};

export const getOptionConstraints = (underlying: UnderlyingSymbol) => {
  return constraints.options[underlying];
};

export const getGeneralConstraints = (underlying: UnderlyingSymbol) => {
  return constraints.general[underlying];
};

export const getPerpSizeDisplayPrecision = (
  underlying: UnderlyingSymbol,
  isUnderlying: boolean,
) => {
  const constraints = getPerpConstraints(underlying);

  if (!constraints) return 0;

  return isUnderlying
    ? constraints.sizeDisplayPrecision
    : constraints.sizeDisplayPrecisionNotional;
};

export const getOptionOrPerpConstraints = (instrument: string) => {
  const isOption = isOptionInstrument(instrument);
  const { underlying } = getInstrumentProperties(instrument);

  return isOption
    ? getOptionConstraints(underlying)
    : getPerpConstraints(underlying);
};

export const optionRfqSizes: Record<UnderlyingSymbol, number[]> = {
  BTC: [25, 50, 100, 200],
  ETH: [250, 500, 1000, 2000],
};

export const perpRfqSizes: Record<UnderlyingSymbol, number[]> = {
  BTC: [200_000, 500_000, 1_000_000, 2_000_000],
  ETH: [100_000, 200_000, 500_000, 1_000_000],
};

export const rfqDurations: number[] = [5, 10, 20];

export const MIN_RFQ_SIZE = 1;
